module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/kr-9406f22f1237e7e4059d43ab60f9fbc8.svg";